// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__27vhV","buttons":"PendingPaymentAlert_buttons__24V9J"};